import { useNavigate } from "react-router-dom";
export const MiscellaneousRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		{
			label: "Country",
			command: () => {
				navigate("/country/setup");
			},
		},
		{
			label: "Province",
			command: () => {
				navigate("/province/setup");
			},
		},
		{
			label: "State",
			command: () => {
				navigate("/state/setup");
			},
		},
		{
			label: "City",
			command: () => {
				navigate("/city");
			},
		},
		{
			label: "Tax Year",
			command: () => {
				navigate("/tax-year/setup");
			},
		},
		{
			label: "Tax Profile",
			command: () => {
				navigate("/tax-profile/setup");
			},
		},
		{
			label: "Global Variables",
			command: () => {
				navigate("/global-variables");
			},
		},
		{
			label: "PDF Files",
			command: () => {
				navigate("/pdf-settings/pdf-files");
			},
		},
		{
			label: "PDF Axis",
			command: () => {
				navigate("/pdf-settings/pdf-axis");
			},
		},
		{
			label: "TD1",
			command: () => {
				navigate("/forms/admin/td1");
			},
		},
		{
			label: "Bank",
			command: () => {
				navigate("/bank");
			},
		},

		{
			label: "Branch",
			command: () => {
				navigate("/branch");
			},
		},
		{
			label: "Minimum Wage Rate",
			command: () => {
				navigate("/minimum-wage-rate");
			},
		},
		{
			label: "Statutory Holiday",
			command: () => {
				navigate("/statutory-holiday");
			},
		},
		{
			label: "BC EHT Settings",
			command: () => {
				navigate("/bc-eht-setting");
			},
		},
		{
			label: "Billing Profile",
			command: () => {
				navigate("/billing-profile");
			},
		},
		{
			label: "Profile Association",
			command: () => {
				navigate("/billing-profile-association");
			},
		},
	];

	return {
		MiscellaneousRoutes: ArrayData,
	};
};
